
import s0 from '~/.nuxt/gb-cms/sections/AwardsAndAcknowledgments'
import s1 from '~/.nuxt/gb-cms/sections/DirectlyTalk'
import s2 from '~/.nuxt/gb-cms/sections/DirectorsBoard'
import s3 from '~/.nuxt/gb-cms/sections/FuelingTheFuture'
import s4 from '~/.nuxt/gb-cms/sections/HeroSection'
import s5 from '~/.nuxt/gb-cms/sections/InnovationAtGauss'
import s6 from '~/.nuxt/gb-cms/sections/OurValues'
import s7 from '~/.nuxt/gb-cms/sections/QualityAtGauss'
import s8 from '~/.nuxt/gb-cms/sections/TimelineSection'
import s9 from '~/.nuxt/gb-cms/sections/WeAreGauss'
import s10 from '~/.nuxt/gb-cms/sections/ApplicationForm'
import s11 from '~/.nuxt/gb-cms/sections/JobRequirements'
import s12 from '~/.nuxt/gb-cms/sections/OpenPositions'
import s13 from '~/.nuxt/gb-cms/sections/OurBenefits'
import s14 from '~/.nuxt/gb-cms/sections/PositionHero'
import s15 from '~/.nuxt/gb-cms/sections/TitleText'
import s16 from '~/.nuxt/gb-cms/sections/ClutchAboutUs'
import s17 from '~/.nuxt/gb-cms/sections/ClutchClients'
import s18 from '~/.nuxt/gb-cms/sections/ClutchCounter'
import s19 from '~/.nuxt/gb-cms/sections/ClutchFaq'
import s20 from '~/.nuxt/gb-cms/sections/ClutchHero'
import s21 from '~/.nuxt/gb-cms/sections/ClutchProjects'
import s22 from '~/.nuxt/gb-cms/sections/ClutchTestimonials'
import s23 from '~/.nuxt/gb-cms/sections/ContactHero'
import s24 from '~/.nuxt/gb-cms/sections/LocationAndContact'
import s25 from '~/.nuxt/gb-cms/sections/MultipleContactForms'
import s26 from '~/.nuxt/gb-cms/sections/ThankYou'
import s27 from '~/.nuxt/gb-cms/sections/AuthenticReliable'
import s28 from '~/.nuxt/gb-cms/sections/BookAMeeting'
import s29 from '~/.nuxt/gb-cms/sections/BusinessSoftware'
import s30 from '~/.nuxt/gb-cms/sections/ContactSection'
import s31 from '~/.nuxt/gb-cms/sections/CustomForm'
import s32 from '~/.nuxt/gb-cms/sections/CustomFormWithLeftText'
import s33 from '~/.nuxt/gb-cms/sections/HomepageHero'
import s34 from '~/.nuxt/gb-cms/sections/LatestBlogs'
import s35 from '~/.nuxt/gb-cms/sections/OurServicesHome'
import s36 from '~/.nuxt/gb-cms/sections/OurWork'
import s37 from '~/.nuxt/gb-cms/sections/QuestionsAnswers'
import s38 from '~/.nuxt/gb-cms/sections/StatisticsSection'
import s39 from '~/.nuxt/gb-cms/sections/TestimonialsSection'
import s40 from '~/.nuxt/gb-cms/sections/ImageAndCategories'
import s41 from '~/.nuxt/gb-cms/sections/NextInLine'
import s42 from '~/.nuxt/gb-cms/sections/OurWorkHero'
import s43 from '~/.nuxt/gb-cms/sections/PrincipleSection'
import s44 from '~/.nuxt/gb-cms/sections/ProjectInfo'
import s45 from '~/.nuxt/gb-cms/sections/SpecialProjectInfo'
import s46 from '~/.nuxt/gb-cms/sections/WorkAndProducts'
import s47 from '~/.nuxt/gb-cms/sections/PrivacyPolicy'
import s48 from '~/.nuxt/gb-cms/sections/OurApproach'
import s49 from '~/.nuxt/gb-cms/sections/OurProcess'
import s50 from '~/.nuxt/gb-cms/sections/OurServices'
import s51 from '~/.nuxt/gb-cms/sections/SingleServiceContactUs'
import s52 from '~/.nuxt/gb-cms/sections/SingleServiceHero'
import s53 from '~/.nuxt/gb-cms/sections/SingleServiceMeasureSuccess'
import s54 from '~/.nuxt/gb-cms/sections/SingleServiceOurPlatform'
import s55 from '~/.nuxt/gb-cms/sections/SingleServiceProjects'
import s56 from '~/.nuxt/gb-cms/sections/SingleServiceQuote'
import s57 from '~/.nuxt/gb-cms/sections/TagPostFilter'
import s58 from '~/.nuxt/gb-cms/sections/H1Section'

const sectionMapper = {
	'awards-and-acknowledgments': s0,
	'directly-talk': s1,
	'directors-board': s2,
	'fueling-the-future': s3,
	'hero-section': s4,
	'innovation-at-gauss': s5,
	'our-values': s6,
	'quality-at-gauss': s7,
	'timeline-section': s8,
	'we-are-gauss': s9,
	'application-form': s10,
	'job-requirements': s11,
	'open-positions': s12,
	'our-benefits': s13,
	'position-hero': s14,
	'title-text': s15,
	'clutch-about-us': s16,
	'clutch-clients': s17,
	'clutch-counter': s18,
	'clutch-faq': s19,
	'clutch-hero': s20,
	'clutch-projects': s21,
	'clutch-testimonials': s22,
	'contact-hero': s23,
	'location-and-contact': s24,
	'multiple-contact-forms': s25,
	'thank-you': s26,
	'authentic-reliable': s27,
	'book-a-meeting': s28,
	'business-software': s29,
	'contact-section': s30,
	'custom-form': s31,
	'custom-form-with-left-text': s32,
	'homepage-hero': s33,
	'latest-blogs': s34,
	'our-services-home': s35,
	'our-work': s36,
	'questions-answers': s37,
	'statistics-section': s38,
	'testimonials-section': s39,
	'image-and-categories': s40,
	'next-in-line': s41,
	'our-work-hero': s42,
	'principle-section': s43,
	'project-info': s44,
	'special-project-info': s45,
	'work-and-products': s46,
	'privacy-policy': s47,
	'our-approach': s48,
	'our-process': s49,
	'our-services': s50,
	'single-service-contact-us': s51,
	'single-service-hero': s52,
	'single-service-measure-success': s53,
	'single-service-our-platform': s54,
	'single-service-projects': s55,
	'single-service-quote': s56,
	'tag-post-filter': s57,
	'h-1-section': s58
}

export default sectionMapper
